import type { GetStaticProps, NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import ContainerHighlighted from "components/utilities/HighlightedContainer/ContainerHighlighted";
import dynamic from "next/dynamic";
import { Container } from "react-bootstrap";
import Layout from "../components/Layout";
import Hero from "../components/Team/Hero/Hero";
import MeetTheCEO from "../components/Team/MeetTheCEO/MeetTheCEO";
import MeetTheTeam from "../components/Team/MeetTheTeam/MeetTheTeam";
import ProfileCardContainer from "../components/Team/ProfileCard/ProfileCardContainer";
import Values from "../components/Team/Values/Values";
import { fetchEmployees } from "../data/employees/employees";
import { team } from "../routes/namespaces";

const BubblesContainer = dynamic(
  () => import("../components/Team/Bubble/BubbleContainer"),
  {
    ssr: true,
  }
);

const Career: NextPage = () => {
  return (
    <Layout title={"team"}>
      <Hero
        title="ViableOne, to je tym skvelych lidi"
        altText="v1 hero"
      />
      <Container>
        <Values />
        <MeetTheCEO />
        <ContainerHighlighted className="py-7">
          <MeetTheTeam />
        </ContainerHighlighted>
        <BubblesContainer />
      </Container>
    </Layout>
  );
};

export default Career;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const queryClient = new QueryClient();

  queryClient.prefetchQuery(
    [
      "employees",
      {
        locale: locale!,
      },
    ],
    fetchEmployees
  );

  return {
    revalidate: 3600,
    props: {
      ...(await serverSideTranslations(
        locale || "cs",
        team,
      )),
      dehydratedState: dehydrate(queryClient)
    },
  };
};
